/**
 * Utilitaire contenant des fonctions statiques pour les chaines
 * @category Utils
 * @hideconstructor
 */
var StringUtils = /*#__PURE__*/function () {
  function StringUtils() {}

  /**
  * Fonction qui renvoie une chaine avec la 1ère lettre en majuscule
  * @param {string} chaine La chaine en entrée
  * @returns {string} La chaine _chaine_ avec la 1ère lettre en majuscule
  */
  StringUtils.firstLetterUpperString = function firstLetterUpperString(chaine) {
    if (StringUtils.validateString(chaine)) {
      return chaine[0].toUpperCase() + chaine.substring(1, chaine.length);
    }

    return "";
  }
  /**
   * Fonction qui renvoie une chaine unique
   * @returns {string} Une chaine unique
   */
  ;

  StringUtils.generateUniqueStr = function generateUniqueStr() {
    return Math.random().toString(36).slice(2);
  }
  /**
   * Fonction qui permet de récupérer la valeur d'un paramètre dans une URL
   * @param {string} paramName Le nom du paramètre
   * @param {string} paramsUrl L'URL, ou juste la partie contenant les paramètres
   * @returns {string} La valeur du paramètre si trouvé, sinon null
   */
  ;

  StringUtils.getParamValueFromUrl = function getParamValueFromUrl(paramName, paramsUrl) {
    var match = paramsUrl.match("[?&]" + paramName + "=([^&]+)");
    return match ? match[1] : null;
  }
  /**
   * Remplace les caractères accentués d'une chaine par les caractères non accentués
   * @param {string} chaine La chaine où l'on veut retirer les accents
   * @returns {string} La chaine en entrée sans les accents
   */
  ;

  StringUtils.replaceAccent = function replaceAccent(chaine) {
    if (!StringUtils.validateString(chaine)) {
      return chaine;
    }

    return chaine.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  /**
   * Fonction permettant de vérifier la validité d'un email
   * @param {string} email L'email à tester
   * @returns {boolean} true si l'email _email_ est valide, false sinon
   */
  ;

  StringUtils.validateEmail = function validateEmail(email) {
    var regexp = RegExp("^\\S+@\\S+\\.\\S+$");
    return regexp.test(email);
  }
  /**
   * Fonction permettant de vérifier qu'une chaine n'est ni vide, ni nulle
   * @param {string} chaine La chaine à tester
   * @returns {boolean} true si la chaine _chaine_ est valide, false sinon
   */
  ;

  StringUtils.validateString = function validateString(chaine) {
    if (!chaine || chaine === null) {
      // Chaîne nulle
      return false;
    }

    if (chaine.trim().length === 0) {
      // Chaîne vide
      return false;
    }

    return true;
  }
  /**
   * Fonction qui renvoie une chaine en majuscule
   * @param {string} chaine La chaine en entrée
   * @returns {string} La chaine _chaine_ en majuscule
   */
  ;

  StringUtils.upperString = function upperString(chaine) {
    if (StringUtils.validateString(chaine)) {
      return chaine.toUpperCase();
    }

    return "";
  };

  return StringUtils;
}(); // Exports


export var firstLetterUpperString = StringUtils.firstLetterUpperString;
export var generateUniqueStr = StringUtils.generateUniqueStr;
export var getParamValueFromUrl = StringUtils.getParamValueFromUrl;
export var replaceAccent = StringUtils.replaceAccent;
export var validateEmail = StringUtils.validateEmail;
export var validateString = StringUtils.validateString;
export var upperString = StringUtils.upperString;